module.exports = __webpack_public_path__ + "sx.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sx.svg
// module id = 1078
// module chunks = 0